import { useEffect, useState } from 'react';

// Isti online/offline browser event koji NetworkStatusWatcher koristi za
// toast — izdvojeno ovdje da MutationButton može proaktivno onemogućiti
// gumb čim veza nestane, ne tek nakon što korisnik klikne i mutacija zapne.
export const useOnlineStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};
